import { FormControl, FormGroup } from "@angular/forms";
import { AssessmentPdfGenerator } from "src/app/patients/dashboard-page/assessments-history-tab/assessment-to-pdf";
import { ControlsOf, AssessmentHelpers, noString } from "./shared";

interface ProviderNotifiedFields {
  isNotified: boolean;
  notifiedPerson: string;
  notifiedWhat: string;
}
export type ProviderNotifiedFormGroup = FormGroup<ControlsOf<ProviderNotifiedFields>>;

export const ProviderNotifiedAssessmentHelpers: AssessmentHelpers = {
  createFormGroup: createProviderNotifiedFormGroup,
  toPDF: providerNotifiedAssessmentToPDF,
  formToObject: formToProviderNotifiedAssessment,
  initialState: {
    isNotified: false,
    notifiedPerson: noString,
    notifiedWhat: noString,
  },
};

export class ProviderNotifiedAssessment {
  /**
   * Represents whether the provider has been notified about the assessment.
   */
  isNotified: boolean;

  /**
   * The person who was notified about the assessment.
   */
  notifiedPerson: string;

  /**
   * What the provider was notified about.
   */
  notifiedWhat: string;

  // All fields are optional in the data parameter.
  constructor(data: Partial<ProviderNotifiedFields>) {
    this.isNotified = data.isNotified ?? ProviderNotifiedAssessmentHelpers.initialState.isNotified;
    this.notifiedPerson = data.notifiedPerson ?? ProviderNotifiedAssessmentHelpers.initialState.notifiedPerson;
    this.notifiedWhat = data.notifiedWhat ?? ProviderNotifiedAssessmentHelpers.initialState.notifiedWhat;
  }
}

function createProviderNotifiedFormGroup(providerNotifiedAssessment?: ProviderNotifiedAssessment) {
  const data = providerNotifiedAssessment || new ProviderNotifiedAssessment(ProviderNotifiedAssessmentHelpers.initialState);
  return new FormGroup<ControlsOf<ProviderNotifiedFields>>({
    isNotified: new FormControl<boolean | null>(data.isNotified),
    notifiedPerson: new FormControl<string | null>(data.notifiedPerson),
    notifiedWhat: new FormControl<string | null>(data.notifiedWhat),
  });
}

function providerNotifiedAssessmentToPDF(pdf: AssessmentPdfGenerator, assessment: ProviderNotifiedAssessment): void {
  pdf.addSectionTitle('Provider Notified');
  pdf.pdf.text(`Notified: ${assessment.isNotified ? 'Yes' : 'No'}`, pdf.margin, pdf.currY);
  pdf.currY += 20;
  if (assessment.isNotified) {
    pdf.addOneColumnText("Who", assessment.notifiedPerson);
    pdf.addOneColumnText("What", assessment.notifiedWhat);
  }
}

function formToProviderNotifiedAssessment(fg: ProviderNotifiedFormGroup) {
  return new ProviderNotifiedAssessment({
    isNotified: fg.controls.isNotified.value!,
    notifiedPerson: fg.controls.notifiedPerson.value!,
    notifiedWhat: fg.controls.notifiedWhat.value!,
  });
}

